import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { MOCK_USER_NAME } from '../availableBalanceSummaryCard.constants';
import styles from '../styles/availableBalanceSummaryCard.module.scss';
import { USDFormatter } from '../../../../../utils/numbers';

function FinalBalanceSection({ availableBalance, userName = MOCK_USER_NAME }) {
    return (
        <div className={styles.finalBalanceCard}>
            <Text as="span" size="xs" className={styles.finalBalanceLabel}>
                {`${userName.toUpperCase()}\u2019S AVAILABLE BALANCE`}
            </Text>
            <Text as="span" size="xl" className={styles.finalBalanceValue}>
                {USDFormatter.format(availableBalance)}
            </Text>
        </div>
    );
}

export default FinalBalanceSection;
